var exports = {
  "k": "x31de4314--073d86--container",
  "Q": "x31de4314--073d86--content",
};

module.exports = exports;
